export class StringValueId {
  id: string;
  value: string;
  imgURL: string;
  //setValue: string;
  //AWM-CP
  defaultValue: string;
  flagged: boolean;
  toolTipKey: string;
}
